import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, OnInit, ViewEncapsulation, input, effect } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import * as util from '../../../shared/services/util.service';
import {Make} from '../../../shared/models/brand.model';
import {VehicleModelYearList} from '../../../shared/models/series-details';
import {ActivatedRoute} from '@angular/router';
import {combineLatest, iif, Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IToyotaLexusModelDetails, ServiceAppointmentState} from '../../../store/service-appointment/service-appointment.reducer';
import * as fromSelectors from '../../../store/service-appointment/service-appointment.selectors';
import {LoadModelYearAndModels} from '../../../store/service-appointment/service-appointment.actions';
import {SubscriptionList} from '../../../shared/models/asp.types';
import {mergeMap, switchMap, filter, take} from 'rxjs/operators';
import * as fromValidator from '../../service-appointment/service-appointment.validator';
import {VehicleService} from '../../../shared/services/vehicle.service';
import {Department, IVehicle} from '@signal/asp-data-commons';
import {BdcDashboardState} from '../../../store/bdcdashboard/bdcdashboard.reducer';
import * as BdcDashboardActions from '../../../store/bdcdashboard/bdcdashboard.actions';
import {selectUserVehicles, selectUserVehiclesLoading, selectMyUserVehiclesCount} from '../../../store/bdcdashboard/bdcdashboard.selectors';
import {LearningVehicleCardComponent} from './learning-vehicle-card/learning-vehicle-card.component';
import { selectAppointmentsForVin } from '../../../store/bdcdashboard/bdcdashboard.selectors';
import * as fromDashboard from '../../../store/bdcdashboard/bdcdashboard.selectors';
import {selectCurrentCustomer, selectPendingSearchInput} from '../../../store/search-customers/search-customers.selectors';
import {SearchCustomersState} from '../../../store/search-customers/search-customers.reducer';
import { SettingsState } from 'src/app/modules/store/settings/settings.reducer';
import { selectSettings } from 'src/app/modules/store/settings/settings.selectors';
import { Telematics } from 'src/app/modules/shared/models/telematics.model';
import { DateTime } from 'luxon';
import { FactoryPrintService } from '../../../shared/components/factory-services-dialog/factory-print.service';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { SalesAppointmentState } from 'src/app/modules/store/sales-appointment/sales-appointment.reducer';
import { UpdatePatchSalesForm } from 'src/app/modules/store/sales-appointment/sales-appointment.actions';
import * as fromSalesSelectors from '../../../store/sales-appointment/sales-appointment.selectors';
import { PartsAppointmentState } from 'src/app/modules/store/parts-appointment/parts-appointment.reducer';
import { UpdatePatchSalesForm as UpdatePatchPartsForm } from 'src/app/modules/store/parts-appointment/parts-appointment.actions';
import * as fromPartsSelectors from '../../../store/parts-appointment/parts-appointment.selectors';
import { AppointmentType } from '@signal/asp-data-commons';
import { StateDetails } from 'src/app/modules/shared/models/state';
import { selectStates } from 'src/app/modules/store/dealer/dealer.selectors';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';

@Component({
  selector: 'app-select-learning-vehicle',
  templateUrl: './select-learning-vehicle.component.html',
  styleUrls: ['./select-learning-vehicle.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectLearningVehicleComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() stepIndex = 0;
  @Input() showMileageField = true;
  @Input() showPartsField = false;
  vehicleInfo = input<any>({});
  src = input<string>("");
  @Output() toShowFooter=new EventEmitter();
  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();
  vehicles: IVehicle[] = [];
  step: UntypedFormGroup;

  title: string;
  switcherText: string;

  isMakeOther = false;
  isOwnVehicle = true;
  isVinMandate=false;
  makes: Make[] = [];
  models : string[] = [];
  yearmodels: string[] = [];
  preSelectedVin: string;
  telematicsLoading : boolean = false;
  isOwnVehicle$: Observable<number>;
  isUserVehiclesLoading$: Observable<boolean>;
  isEditMode$: Observable<any>;
  modelYearAndModelsLoading$: Observable<boolean>;
  newvehicle:any;
  milesPlaceholder : string;
  milesIsRequired : string;
  apptType: string = AppointmentType.LEARNING

  hasExistingAppt = false;
  existingApptText = '';
  isVehicleSelected:boolean=false;
  selectedVehicleDetails : {
    make:string,
    year:string,
    model:string,
  };
  previousMakeModelYear = '';
  dateFormat : string = 'yyyy-MM-dd'
  filterOptions:any = [
    {
        "filterId": "vin",
        "filterName": "VIN"
    }
  ]
  filterOptionSelected = 'vin';
  stateOptionSelected;
  statesList;
  filteredStatesList;
  selectedOption = 'service.vin';
  states$: Observable<StateDetails[]>;
  vehicleNotFound = false;
  isSubmitting = false;
  vehicleFound = false;
  isLicenseToVinEnabled = util.getLicenseToVinEnabled();

  private modelYearSeries: VehicleModelYearList;
  private subs: SubscriptionList = {};
  private modelYearAndModelsData$: Observable<IToyotaLexusModelDetails>;
  isEditMode: boolean;
  private lastVehicleSelected: string;
  private toyotaLexusModelDetails: IToyotaLexusModelDetails;
  private lastValue : any;
  signalDeeplinkId="";
  srcInternal="";
  isEditAppointmentFlow = false;
  private firstTime=true;
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly vehicleService: VehicleService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly cdRef: ChangeDetectorRef,
    private readonly bdcDashboardState: Store<BdcDashboardState>,
    private readonly bannerService: AspBannerService,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly salesAppointmentState: Store<SalesAppointmentState>,
    private readonly partsAppointmentState: Store<PartsAppointmentState>,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private settingsState: Store<SettingsState>,
    private factoryPrintService: FactoryPrintService,
    private readonly translate: TranslateService,
    private readonly dealerState: Store<DealerState>
  ) {
    this.makes = util.getMakes();
    this.bindThis();
    this.milesPlaceholder = this.translate.instant(`service.${this.translate.instant('COUNTRYTRANSLATION.enterMile')}`);
    this.milesIsRequired = this.translate.instant(`service.${this.translate.instant('COUNTRYTRANSLATION.milesIsRequired')}`);

    this.subs.query = this.activatedRoute.queryParams.subscribe(params => {
      this.isVehicleSelected = params.selectedVehicle ? true :false;
      if(params.selectedVehicle && !params.vin){
        this.selectedVehicleDetails = {
          year : params.year,
          make : params.make,
          model : params.model
        }
      }else{
        this.preSelectedVin = params.vin;
      }
    });
    effect(() => {
      this.srcInternal =  this.src();
      const vehicle = this.vehicleInfo();
      if((vehicle.vin || (vehicle.make && vehicle.model && vehicle.year)) && this.firstTime) {
        if (vehicle.make && this.isOtherMake(vehicle.make)) {
          this.isMakeOther = true; 
        }
        this.firstTime = false;
        this.step.patchValue(vehicle);
      }
    });
  }

  ngOnInit(): void {
    this.subs.appts = this.bdcDashboardState.select(fromDashboard.selectLearningAppointmentsForDashboard).subscribe((response)=>{
      const temp = []
      const uniqueResponse = response.map(obj => {
        if(!temp.includes(obj.vin)){
          temp.push(obj.vin)
          return obj
        }
      }).filter(f => f)
      this.newvehicle = uniqueResponse.filter((item)=>{
        return item.isOwnVehicle;
      });
     });

    this.dealerState.select(selectStates).pipe(
      filter((states): states is StateDetails[] => Array.isArray(states) && states.length > 0),
      take(1)
    )
    .subscribe(states => {
      this.statesList = states;
      this.filteredStatesList = [...states];
    });
    
    if(this.isLicenseToVinEnabled){
      this.filterOptions.push({
        "filterId": "licensePlate",
        "filterName": "License Plate"
      })
    }
    this.ready();
  }

  private patchVehicleToStore(value: any) {
    if (this.showPartsField) {
      this.partsAppointmentState.dispatch(new UpdatePatchPartsForm({
        path: 'vehicle',
        value
      }));
      return;
    }

    this.salesAppointmentState.dispatch(new UpdatePatchSalesForm({
      path: 'vehicle',
      value
    }));
  }

  onVehicleFieldChange(
    change: { field: string; value: string },
    vehicle: IVehicle
  ) {
    /* Handle mileage and parts fields changes */
    setTimeout(() => {
      if (change.field === 'mileage') {
        if (this.step.controls.vin.value === vehicle.vin) {
          this.setFormControlValue('mileage', +(change?.value || 0));
        } else {
          this.patchVehicleToStore({ ...vehicle, mileage: +(change?.value || 0), isOwnVehicle: true });
        }
      } else if (change.field === 'orderRefNumber' || change.field === 'dealerOrderNumber') {
        // Handle parts field changes - always update form control
        this.setFormControlValue(change.field, change.value);
      }
    
    });
  }

  /**
   * Sets the necessary fields and form validators based on vehicle type 'Own' or 'Different'
   */
  toggleVehicleType() {
    this.resetAllInputs();
    if (this.isOwnVehicle) {
      this.setOwnVehicleFalse();
    } else {
      this.setOwnVehicleTrue();
    }
  }

  /**
   * Sets the subscriptions of the current step form
   *
   * 1. Make formControl - to check whether 'Other' is chosen or not
   */
   setFormSubscription() {
    this.subs.makeSub = this.step.get('make').valueChanges.subscribe((make: string) => {
      if (this.step.get('isOwnVehicle')?.value || this.srcInternal === 'signal') {
        return;
      }
      if (this.isOtherMake(make)) {
        this.isMakeOther = true;
        this.step.controls.year.reset(null, {emitEvent: false});
        this.step.controls.model.reset(null, {emitEvent: false});
      } else {
        this.isMakeOther = false;
        if (make === 'Toyota') {
          this.modelYearSeries = this.toyotaLexusModelDetails.toyota;
        } else if (make === 'Lexus') {
          this.modelYearSeries = this.toyotaLexusModelDetails.lexus;
        }
        this.step.controls.year.reset('', {emitEvent: false});
        this.step.controls.model.reset('', {emitEvent: false});
        if(this.modelYearSeries){
          const yearArray = Object.keys(this.modelYearSeries).sort((a, b) => b.localeCompare(a));
          this.yearmodels = yearArray;
        }else{
          this.yearmodels = [];
        }
        this.step.controls.model.reset('', {emitEvent: false});
        this.step.controls.imageUrl.reset('', {emitEvent: false});
        this.models=[];
      }
      this.resetGroupTwoFields(make);
    });

    this.subs.yearSub = this.step.get('year').valueChanges.subscribe((data: string) => {
      if (this.step.get('isOwnVehicle')?.value || this.srcInternal === 'signal') {
        return;
      }
      if (!this.isMakeOther) {
        const chosenYear = this.step.controls.year.value;
        if (this.modelYearSeries && chosenYear) {
          const dataOfModel = this.modelYearSeries[chosenYear];
          const sortedModelKeys = Object.keys(dataOfModel).sort((a,b)=> a.localeCompare(b));
          this.models = sortedModelKeys;
        }
      }
      this.step.controls.model.reset('', {emitEvent: false});
      this.step.controls.imageUrl.reset('', {emitEvent: false});
      this.resetGroupTwoFields(data);
    });
    this.subs.modelSub = this.step.get('model').valueChanges.subscribe((data: string) => {
      if (this.step.get('isOwnVehicle')?.value || this.srcInternal === 'signal') {
        return;
      }
      this.resetGroupTwoFields(data);
    });

    this.subs.vinSub = this.step.get('vin').valueChanges.subscribe((data: string) => {
      if (this.step.get('isOwnVehicle')?.value) {
        return;
      }
      this.resetGroupOneFields(data);
    
      if (data && data.length === 17 && this.filterOptionSelected === 'vin' && !this.isMakeOther) {
        this.subs.vehicleDetails = this.vehicleService.getVehicleColorForLexus({ vin: data }, false).subscribe(
          response => {
            if (response && response.status?.code === 201 && response.data && response.data.length > 0) {
              if (this.srcInternal === "signal") {
                const vehicle = {
                  make: response.data[0].make,
                  model: response.data[0].model,
                  year: String(response.data[0].year),
                  imageUrl: response.data[0].imageUrl
                }
                this.step.patchValue(vehicle);
                this.showVehicle(vehicle.imageUrl);
              } else {
                this.bannerService.show();
                const imageUrl = response.data[0].imageUrl;
                this.step.controls.imageUrl.setValue(imageUrl);
                this.showVehicle(imageUrl);
              }
            }
          },
          _error => {
            this.step.controls.imageUrl.setValue(undefined);
            this.bannerService.show();
            this.hideVehicle();
          }
        );
      }
    });

    this.subs.licensePlateSub = this.step.get('licensePlate').valueChanges.subscribe((data: string) => {
      const mileageControl = this.step.get('mileage');
      mileageControl.markAsUntouched();
      this.step.controls.state.patchValue('', {emitEvent: false});
      this.resetInfoText();
      if(!data || data.length<2){
        this.step.controls.state.disable();
      }else if(data.length>1) {
        this.step.controls.state.enable();
      }
    })
    
    this.subs.vehicleImageSub = this.step.valueChanges.subscribe(value => {
      // const rawValue = this.step.getRawValue();
      /* When the vehicle info is partial, no need to set image */
      if(this.srcInternal === 'signal') {
        return;
      }
      if (!this.missingCoreFields(value)) {
        if(!this.isEditMode && !(value.vin)){
          this.hideVehicle();
        }
        return;
      }

      const chosenVehicle = `${value.make}#${value.year}#${value.model}`;
      if (this.lastVehicleSelected === chosenVehicle) {
        return;
      }

      this.lastVehicleSelected = chosenVehicle;
        /* Other makes don't have images in EFC */
        if (this.isOtherMake(value.make)) {
          this.step.controls.imageUrl.setValue(util.GLOBAL_CONSTANT.placeholderCarImage);
          return;
        }
      if(this.previousMakeModelYear !== `${value.make}${value.model}${value.year}`){
        this.previousMakeModelYear = `${value.make}${value.model}${value.year}`;
        this.hideVehicle();
      }
      if(util.countryCd.includes('US')) {
        if(!value.isOwnVehicle){
          const modelData = this.modelYearSeries?.[value.year]?.[value.model];
          const relativeURL = modelData?.['carJellyImageUrl'];
          this.step.controls.imageUrl.setValue(relativeURL);
          this.bannerService.show();
          if(relativeURL) {
            this.showVehicle(relativeURL);
          }
        } else {
          this.showVehicle(value.imageUrl);
        }
      } 
      /* // this is else logic dealing with vehicle images for other than us country  
      else {
        const brand = value.make.toUpperCase().substr(0, 3);
        let model;
        if (value.make.toLowerCase() === 'toyota') {
          model = value.model.toLowerCase().replace(' ', '');
          if(!value.isOwnVehicle){
            this.subs.color = this.vehicleService.getVehicleColors(brand, value.year, model, '').subscribe((data: VehicleImage) => {
              const exteriorColors = data.colors?.exterior;
              const exteriorColor = exteriorColors[0];
              const relativeURL = brand?.toLowerCase() === 'lex'?
              exteriorColor?.applicable[0]?.override?.images?.on_swatch_image :
              exteriorColor?.applicable[0]?.override?.images?.car_jelly_image ;
    
              // Updating the image url in the form
              this.step.controls.imageUrl.setValue(relativeURL);
              this.bannerService.show();
              this.showVehicle(relativeURL);
            },err=>{
              this.step.controls.imageUrl.setValue(undefined);
              this.factoryPrintService.setUrl(undefined);
              this.bannerService.show();
              this.hideVehicle();
            });
          }else{
            this.showVehicle(value.imageUrl);
          }
        } else if (value.make.toLowerCase() === 'lexus') {
          model = value.model.toLowerCase().replace(/[0-9]/g, '').replace(' ', '');
          if(!value.isOwnVehicle){
            this.subs.vehicleData = this.vehicleService.getVehicleColorForLexus(value, false).subscribe(data=>{
            if(data  && data.status?.code === 201 && data.data && data.data.model && data.data.model.length> 0){
              this.bannerService.show();
              this.step.controls.imageUrl.setValue(data.data.model[0]);
              this.showVehicle(data.data.model[0]);
            }else{
              this.step.controls.imageUrl.setValue(undefined);
              this.hideVehicle();
            }
          },err=>{
            this.step.controls.imageUrl.setValue(undefined);
            this.bannerService.show();
            this.hideVehicle();
            })
          }else{
            this.showVehicle(value.imageUrl);
          }
        }else{
          this.hideVehicle();
        }
      } */
    });

    this.subs.updateVehicleChanges = this.step.valueChanges.subscribe((data)=>{
      if(this.isValueOld(data)){
        return
      }
      
      this.lastValue = data;
      this.patchVehicleToStore({ ...this.vehicles[0], ...this.lastValue });
    })
    this.formEdited.emit(!this.step.dirty);
  }

  missingCoreFields(value) {
    return value.make && value.year && value.model
  }

  resetGroupOneFields(value: string) {
    if (!!value) {
      this.hasExistingAppt = false;
     if(value.length == 17)
     {
       const queryText = value;
        this.bdcDashboardState.dispatch(new BdcDashboardActions.LoadAppointmentsForVin({ queryText }));
        this.subs.apptForVin = this.bdcDashboardState.select(selectAppointmentsForVin).subscribe(response=>{
          if(response && response.length>0 && response[0]){
            const dateArray = [];
            let count=0;
            const today = DateTime.now().toFormat(this.dateFormat);
            const currentdate = DateTime.fromFormat(today,this.dateFormat);
            const length = response.length;
            for(let i=0;i<length;i++){
              const minDate=DateTime.fromFormat(response[i].appointmentStartDate,this.dateFormat);
              if(minDate>=currentdate && count <=9)
             {
              const displayDate = minDate.toFormat('MMM dd');
              dateArray.push(displayDate);
              this.hasExistingAppt = true;
              count++;
              }
            }
            const sortedDatesArray = this.sortDateArray(dateArray);
          const lastElement = count>1 && sortedDatesArray.length>0 ? 'and '+ sortedDatesArray.splice(count-1,1) : '';
            this.existingApptText = `${this.translate.instant('service.vehicleHasUpcomingAppointmentsScheduledOn')} ${dateArray.join()} ${lastElement}`;
          }else{
            this.hasExistingAppt = false;
            this.step.controls.isInputVinBased.setValue(true);
          }
          this.fetchMilageFromTelematics(value);
        });
     }
      this.step.controls.imageUrl.setValue(util.GLOBAL_CONSTANT.placeholderCarImage);
      this.step.controls.make.reset('', {emitEvent: false});
      this.step.controls.year.reset('', {emitEvent: false});
      this.step.controls.model.reset('', {emitEvent: false});
      this.step.controls.otherMake.reset('', {emitEvent: false});
    }
  }

  fetchMilageFromTelematics(vin:string){
    if(!this.telematicsLoading){
      if(this.isEditMode){
        this.patchVehicleToStore({ ...this.vehicles[0], mileage: 'fetching data from telematics...' });
      }else{
        this.setFormControlValue("mileage",this.translate.instant('service.fetchingDataFromTelematics'));
      }
      if(this.isEditMode){
        this.setTelematics(vin,this.vehicles[0].mileage);
      }else{
        this.setTelematics(vin,null);
      }
    }
  }

  private setTelematics(vin,previousMilage) {
    this.telematicsLoading = true;
    const milesPlaceholderTxt = this.translate.instant(`service.${this.translate.instant('COUNTRYTRANSLATION.enterMile')}`);
    this.subs.telematicsForVin = this.vehicleService.getTelematics(vin,Department.SALES)
      .subscribe(data => {
        if (data.status.code === 200) {
          this.milesPlaceholder = milesPlaceholderTxt;
          const telematicsData = Telematics.getTelematics(data?.data);
          const mileage = telematicsData?.mileage ? telematicsData?.mileage : previousMilage;
          const ppmEligible = telematicsData?.protectionProduct?.protectionProductAvailableScore > 0 ? true : false;
          const protectionProducts = telematicsData?.protectionProduct?.protectionProducts;
          if(this.isEditMode){
            this.patchVehicleToStore({ ...this.vehicles[0], mileage: mileage, protectionProducts, ppmEligible });
          }else{
            this.step.controls['protectionProducts'].setValue(protectionProducts);
            this.step.controls['ppmEligible'].setValue(ppmEligible);
            this.step.controls['mileage'].setValue(mileage);
          }
        }
        this.step.controls['mileage'].enable();
        this.telematicsLoading = false;
      },err=>{
          this.milesPlaceholder = milesPlaceholderTxt;
          if(this.isEditMode){
            this.patchVehicleToStore({ ...this.vehicles[0], mileage: previousMilage  });
          }else{
            this.step.controls['mileage'].setValue(previousMilage);
          }
          this.step.controls['mileage'].enable();
          this.telematicsLoading = false;
      });
  }

  resetGroupTwoFields(value: string) {
    if (!!value) {
      this.step.controls.isInputVinBased.setValue(false);
      this.hasExistingAppt = false;
      this.step.controls.mileage.setValue('');
      this.step.controls.vin.reset('', {emitEvent: false});
    }
  }

  /**
   * Triggers the value change event of the given formGroup, by re-setting one of the form control value
   *
   */
  triggerValueChangeEvent(step: UntypedFormGroup) {
    this.setFormControlValue('isOwnVehicle', step?.controls.isOwnVehicle.value);
  }

  /**
   * Sets the form control value to the given form control name in the formGroup
   */
  setFormControlValue(formControlName: string, formControlValue: any) {
    this.step.controls[formControlName].markAsDirty();
    this.step.controls[formControlName].setValue(formControlValue);
  }

  /**
   * Validates the VIN input having error for 17 digit validation
   *
   * @returns true if control is valid
   */
  isNot17Digit(): boolean {
    return (
      this.step.controls.vin.errors?.pattern &&
      this.step.controls.vin.errors?.pattern?.requiredPattern === '^[.]{17}$'
    );
  }

  /**
   * Validates the VIN input having error for alpha numeric validation
   */
  isNotCharAndDigit(): boolean {
    return (
      this.step.controls.vin.errors?.pattern &&
      this.step.controls.vin.errors?.pattern?.requiredPattern === '^[\\w\\d]*$'
    );
  }

  onKeyPress($event) {
  }

  ready() {
    this.prepareForm();
    this.setUpStore();
    // this.gsap.animateOwnVehicleCards(); //TODO - Restore the animation
  }

  ngOnDestroy(): void {
    util.unsubscribeSubscriptions(this.subs);
    this.cdRef.detach();
  }

  ngAfterViewInit(): void {
    // this.setInitialVehicleSelection();
    this.cdRef.detectChanges();
  }

  vehicleSelected(vehicle: IVehicle, vehicleCardComponent: LearningVehicleCardComponent) {
    this.step.patchValue({...vehicle});
    vehicleCardComponent.triggerOnMileageChange();
  }

  private resetAllInputs() {
    ['mileage', 'description', 'imageUrl'].forEach(fc => this.step.controls[fc].reset('', {emitEvent: false}));
    this.resetGroupOneFields('value');
    this.resetGroupTwoFields('value');
  }

  /**
   * Prepares the form group for vehicle selection with necessary form controls with default value
   */
  private prepareForm() {
    this.step = this.formBuilder.group({
        isOwnVehicle: [true],
        isInputVinBased: [false],
        description: [''],
        imageUrl: [''],
        vin: [''],
        licensePlate: [''],
        state: [''],
        make: [''],
        otherMake: [''],
        year: [''],
        model: [''],
        mileage: [0],
        protectionProducts: [],
        ppmEligible: [false]
      }
    );
    this.step.setValidators(fromValidator.chooseVehicleValidator(this.apptType, this.showPartsField));
    if (this.showPartsField) {
      this.step.addControl('orderRefNumber', new UntypedFormControl('', [this.alphanumbericValidator()]));
      this.step.addControl('dealerOrderNumber', new UntypedFormControl('', [this.alphanumbericValidator()]));
    }
    this.setFormSubscription();
    
  }

  alphanumbericValidator(): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors | null => {
      const value = control.value?.toString().trim();
      if (!value) {
        return null;
      }
      const alphanumericRegex = /^[a-z0-9]+$/i;
      return alphanumericRegex.test(value) ? null : { alphanumeric: true };
    };
  }

  isValueOld(newValue) {
    const lastValueString = JSON.stringify(this.lastValue);
    const newValueString = JSON.stringify(newValue);
    return lastValueString === newValueString;
  }

  private bindThis() {
    this.isNotCharAndDigit = this.isNotCharAndDigit.bind(this);
    this.isNot17Digit = this.isNot17Digit.bind(this);
  }

  private setOwnVehicleTrue() {
    this.isOwnVehicle = true;
    this.title = this.translate.instant('service.chooseFromCustomerVehicles');
    this.switcherText = this.translate.instant('service.chooseAnotherVehicle');
    this.step.controls.isOwnVehicle.setValue(this.isOwnVehicle);
    if(!!this.preSelectedVin){
      // this.step.controls.vin.setValue(this.preSelectedVin);
      if(this.preSelectedVin && this.preSelectedVin.length === 17 && !this.isMakeOther)
      {   
        this.subs.vehicleData = this.vehicleService.getVehicleColorForLexus({vin : this.preSelectedVin}, false).subscribe(data=>{
          if(data  && data.status?.code === 201 && data.data && data.data.length> 0){
            this.bannerService.show();
            this.step.patchValue({...data.data[0]});
            this.showVehicle(data.data[0].imageUrl);
          }
          },err=>{
          this.step.controls.imageUrl.setValue(undefined);
          this.bannerService.show();
          this.hideVehicle();
          })
      }
    }
    // this.gsap.animateOwnVehicleContainer();
  }

  private setOwnVehicleFalse() {
    this.isOwnVehicle = false;
    this.translate.get('service.enterCustomerVehicleDetails').subscribe(trans => {
      this.title = trans;
    });
    this.translate.get('service.chooseFromCustomerVehicles').subscribe(trans => {
      this.switcherText = trans;
    });
    this.step.controls.isOwnVehicle.setValue(this.isOwnVehicle);
    // this.gsap.enterDifferentVehicleContainer();
  }

  private isOtherMake(make: string) {
    return make.toLowerCase() === 'other';
  }

  private setInitialVehicleSelection() {
    if (this.preSelectedVin && this.vehicles?.length) {
      const vehicle = this.vehicles.find(v => v.vin === this.preSelectedVin);
      if(vehicle == undefined && this.isVehicleSelected){
        this.patchVehicleToStore({vin : this.preSelectedVin, isOwnVehicle: false});
        return;
      }
      if(this.isVehicleSelected){
        this.vehicles = this.vehicles.filter(vehicle=>{
         if( vehicle.vin===this.preSelectedVin) {
           this.step.patchValue({...vehicle});
          return vehicle;
         }
        });
      }
      if (this.step.controls.vin.value !== vehicle.vin) {
        this.setTelematics(vehicle.vin,vehicle.mileage);
        this.patchVehicleToStore({...vehicle, ppmEligible: this.step.get('ppmEligible').value, protectionProducts: this.step.get('protectionProducts').value,  isOwnVehicle: true});
      }
    }else if(this.selectedVehicleDetails && this.isVehicleSelected){
      this.patchVehicleToStore({ make : this.selectedVehicleDetails.make , model : this.selectedVehicleDetails.model , year : this.selectedVehicleDetails.year , isOwnVehicle: false});
    }
  }

  private setUpStore() {
    this.serviceAppointmentState.dispatch(new LoadModelYearAndModels());

    /* Observables */
    this.isUserVehiclesLoading$ = this.bdcDashboardState.select(selectUserVehiclesLoading);
    this.isEditMode$ = this.showPartsField
      ? this.partsAppointmentState.select(fromPartsSelectors.isEditModeInEditDetails)
      : this.salesAppointmentState.select(fromSalesSelectors.isEditModeInEditDetails);
    // this.isOwnVehicle$ = this.salesAppointmentState.select(fromSalesSelectors.selectVehicleFormIsOwnVehicle);
    this.isOwnVehicle$ = this.bdcDashboardState.select(selectMyUserVehiclesCount);
    this.modelYearAndModelsData$ = this.serviceAppointmentState.select(fromSelectors.selectModelYearAndModelsData);
    this.modelYearAndModelsLoading$ = this.serviceAppointmentState.select(fromSelectors.selectModelYearAndModelsLoading);

    /* Explicit subscriptions to the store slices */
    this.subs.isOwnVehicleSub = this.isOwnVehicle$.subscribe(vec => {
      vec>0 ? this.setOwnVehicleTrue() : this.setOwnVehicleFalse();

    });
    this.subs.settings = this.settingsState.select(selectSettings).subscribe(settings => {
      this.isVinMandate = settings?.portal?.mandateVin;
      if (this.isVinMandate) {
        this.step.controls.vin.setValidators(this.vinValidator());
      }
    });

      this.subs.editAndCustomer = combineLatest([
        this.isEditMode$.pipe(switchMap((obj: any) => {
          this.isEditMode = obj;
          return this.searchCustomersState.select(selectCurrentCustomer);
        })),
        this.showPartsField
          ? this.partsAppointmentState.select(fromPartsSelectors.selectVehicleForm)
          : this.salesAppointmentState.select(fromSalesSelectors.selectVehicleForm),
        this.searchCustomersState.select(selectPendingSearchInput)
      ]).subscribe(([customer, vehicleForm, pendingSearchInput]) => {
        if (this.isEditMode || this.isEditAppointmentFlow) {
          return;
        }

        if (!customer) {
          const isPendingVinFlow = this.showPartsField && pendingSearchInput?.filterType === 'vin';
          const pendingVin = (pendingSearchInput?.query || '').trim();
          const effectiveVehicleForm = vehicleForm || this.step?.value || {};
          const isVehicleFormEmpty = !effectiveVehicleForm?.vin
            && !effectiveVehicleForm?.licensePlate
            && !effectiveVehicleForm?.make
            && !effectiveVehicleForm?.year
            && !effectiveVehicleForm?.model;

          if (isPendingVinFlow && !!pendingVin && isVehicleFormEmpty) {
            const shouldPatchVinPrefill = effectiveVehicleForm?.vin !== pendingVin
              || effectiveVehicleForm?.isInputVinBased !== true
              || effectiveVehicleForm?.isOwnVehicle !== false;

            if (shouldPatchVinPrefill) {
              this.vehicleService.clearCurrentCustomerTelematics();
              this.filterOptionSelected = 'vin';
              this.step.patchValue(
                { vin: pendingVin, licensePlate: '', state: '', isInputVinBased: true, isOwnVehicle: false },
                { emitEvent: false }
              );
              this.patchVehicleToStore({
                ...this.step.value,
                vin: pendingVin,
                licensePlate: '',
                state: '',
                isInputVinBased: true,
                mileage: '',
                isOwnVehicle: false
              });
            }
            return;
          }

          if (isVehicleFormEmpty) {
            const shouldPatchVehicleForm = effectiveVehicleForm?.isOwnVehicle !== false
              || effectiveVehicleForm?.isInputVinBased !== false;
            if (shouldPatchVehicleForm) {
              this.patchVehicleToStore({
                ...this.step.value,
                mileage: effectiveVehicleForm?.mileage ?? '',
                isOwnVehicle: false,
                isInputVinBased: false
              });
            }
          }
        }
      });
    /* For the guest user the default value for 'isOwnVehicle' is false */
    /*if (!this.signedIn) {
      const vehicle = {...this.step.value, isOwnVehicle: false};
      this.serviceAppointmentState.dispatch(new UpdateServiceForm({path: 'vehicleForm', value: vehicle}));
    }*/

    this.subs.displayVehiclesSub =
      this.isEditMode$.pipe(
        switchMap((obj: any) =>
          iif(() => {
              this.isEditMode = obj;
              return this.isEditMode;
            },
            this.showPartsField
              ? this.partsAppointmentState.select(fromPartsSelectors.editAppointmentVehicle)
              : this.salesAppointmentState.select(fromSalesSelectors.editAppointmentVehicle),
            this.bdcDashboardState.select(selectUserVehicles)
          ))).subscribe((vehicles: any[]) => {
        this.vehicles = (vehicles || []).filter(v => !!v) as IVehicle[];
        if (this.isEditMode) {
            this.prepareFormForEdit(this.vehicles);
          } else {
            this.setInitialVehicleSelection();
          }
      });

    this.subs.modelYearAndModelsDataSub = this.isEditMode$.pipe(
      mergeMap((isEditMode: boolean) =>
        iif(() => !isEditMode, this.modelYearAndModelsData$)
      )
    ).subscribe(data => {
      this.toyotaLexusModelDetails = data;
    });
  }

  private prepareFormForEdit(vehicles) {
    vehicles = vehicles.map(v => ({
      ...v,
      year: v?.year === 'undefined' ? null : v?.year
    }));
    this.bannerService.update(vehicles[0].imageUrl);
    this.bannerService.showCarImage();
    this.unsubCreateModeSubscription();

    /* Disable the formControls (fc) which are not editable */
    const nonEditableControls = ['make', 'otherMake', 'year', 'model', 'vin'];
    nonEditableControls.forEach(fc => this.step.controls[fc]
      ?.disable({ emitEvent: false }));
    if(vehicles[0].vin){
      this.fetchMilageFromTelematics(vehicles[0].vin)
    }
    this.yearmodels = vehicles.map(v => v.year == 'undefined' ? null : v.year);
    this.models = vehicles.map(v => v.model);
    this.isMakeOther=(vehicles[0].make && vehicles[0].make.toString().toLowerCase()==='other' && 
    vehicles[0].isOwnVehicle===false) ? true : false;
    this.step.patchValue(vehicles[0],
    { emitEvent: false });
    this.telematicsLoading = true;
    this.subs.displayVehiclesSub?.unsubscribe();
    this.subs.updateVehicleChanges?.unsubscribe();

    /* Handle order number changes during edit mode */
    if (this.showPartsField) {
      this.subs.editModeOrderNumberChanges?.unsubscribe();
      this.subs.editModeDealerOrderChanges?.unsubscribe();

      const orderRefControl = this.step.get('orderRefNumber');
      const dealerOrderControl = this.step.get('dealerOrderNumber');
        if (orderRefControl) {
        this.subs.editModeOrderNumberChanges = orderRefControl.valueChanges.subscribe((orderRef) => {
          this.patchVehicleToStore({
            ...this.vehicles[0],
            ...this.step.getRawValue(),
            orderRefNumber: orderRef
          });
          this.formEdited.emit(!this.step.dirty);
        });
      }
      
      if (dealerOrderControl) {
        this.subs.editModeDealerOrderChanges = dealerOrderControl.valueChanges.subscribe((dealerOrder) => {
          this.patchVehicleToStore({
            ...this.vehicles[0],
            ...this.step.getRawValue(),
            dealerOrderNumber: dealerOrder
          });
          this.formEdited.emit(!this.step.dirty);
        });
      }
    }
  }

  private unsubCreateModeSubscription() {
    ['vinSub', 'modelSub', 'yearSub', 'makeSub']
      .forEach( sub => this.subs[sub]?.unsubscribe());
  }
  toShowFooterDetails(event){
    this.toShowFooter.emit(event);
  }
  vinValidator(): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors => {
      if (!this.step.controls.vin.value) {
        return { required: this.translate.instant('service.vinIsRequired') };
      } else {
        return null;
      }
    };
  }
  private sortDateArray(dateArray:string[]):string[]{
    const sortedDatesArray = dateArray.sort((a, b) => {
      return <any>new Date(b) - <any>new Date(a);
    });
    return sortedDatesArray.reverse()
  }
  showVehicle(relativeURL){
    this.bannerService.showCarImage();
    this.bannerService.update(relativeURL);
    this.factoryPrintService.setUrl(relativeURL);
  }
  hideVehicle(){
    this.bannerService.hideCarImage();
    this.bannerService.update(undefined);
    this.factoryPrintService.base64CarImg = undefined;
  }
  isVehicleAtOwnedVehicles(){
    return _.every(this.newvehicle.map(vehicle => this.vehicles[0]?.vin !== vehicle?.vin));
  }
  
  hasError(controlName: string, errorName: string){
    return this.step.get(controlName).hasError(errorName);
  }

  filter(value): void {
    const filterValue = value.toLowerCase();
    this.filteredStatesList = this.statesList.filter(o => o.name.toLowerCase().includes(filterValue));
  }

  displayStateName = (abbrev: string) => {
    if (!abbrev) {
      return '';
    }
    const state = this.statesList.find(s => s.abbreviation === abbrev);
    return state ? state.name : '';
  };

  onSelectingFilterOption(value){
    this.resetInfoText();
    this.filterOptionSelected = value;
    this.step.patchValue({ licensePlate : '' });
    this.step.patchValue({ vin : '', emitEvent: false});
    this.step.controls.licensePlate.setValidators([Validators.required]);
    this.step.controls.licensePlate.markAsUntouched();
    this.step.controls.licensePlate.setErrors(null);
    this.selectedOption = 'service.'+value;
    if(value === 'licensePlate'){
      this.step.controls.state.setValidators([Validators.required]);
      this.step.updateValueAndValidity();
    }else {
      this.step.controls.state.patchValue('');
      this.step.controls.state.setValidators([]);
      this.step.controls.state.setErrors(null);
      this.step.updateValueAndValidity();
    }
  }

  onOptionSelected(){
    const licensePlate = this.step.get('licensePlate').value;
    const state = this.step.get('state').value
    this.searchByLicensePlate(licensePlate, state);
  }

  searchByLicensePlate(licensePlate, state){
    this.isSubmitting = true;
    this.resetInfoText();
    this.step.controls.vin.patchValue('')
    this.subs.vehicleDetails = this.vehicleService.searchByLicensePlate(licensePlate, state).subscribe(
      response => {
        this.isSubmitting = false;
        if (response?.data?.[0]?.vin)  {
          this.step.controls.vin.patchValue(response?.data[0]?.vin)
          this.vehicleFound = true;
        }else {
          this.vehicleNotFound = true;
        }
      },
      _error => {
        this.isSubmitting = false;
        this.vehicleNotFound = true;
      }
    );
  }

  resetInfoText(){
    this.vehicleNotFound = false;
    this.vehicleFound = false;
    this.hasExistingAppt = false;
  }
}
